"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DateRangePicker_1 = require("./DateRangePicker");
require("./JQueryExtensions");
(function (w, $) {
    if (!$)
        return false;
    var dateRangePickerExtension = {
        dateRangePicker: function (options) {
            return this.each(function () {
                var obj = $(this);
                new DateRangePicker_1.DateRangePicker(obj, options);
                return this;
            });
        }
    };
    $.fn.extend(dateRangePickerExtension);
})(window, $);
